import { useEffect, useState } from 'react'
import { getDocument } from 'services/firestore'

const useGetOfferFeatures = (offer) => {
  const [features, setFeatures] = useState([])
  const [loading, setLoading] = useState(!!offer?.featureIds?.length)

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true)
      const promises = offer.featureIds.map((feature) =>
        getDocument('features', feature)
      )
      const data = await Promise.all(promises)
      setFeatures(data)
      setLoading(false)
    }

    offer?.featureIds?.length && fetchData()
  }, [offer])

  return [features, loading]
}

export default useGetOfferFeatures
